{
  "CCPADontSellButton": "Ne vendez pas et ne partagez pas mes renseignements personnels",
  "NewAddressAdding": "L'unité peut être saisie à l'étape suivante",
  "RemoveDeliveryAddressConfirmation": "Supprimer la confirmation d'adresse de livraison",
  "about": "À propos",
  "accept": "Accepter",
  "acceptEmailsAndSpecialOffers": "Je souhaite recevoir par courriel des informations et des offres spéciales de Burger King",
  "acceptGiftSuccess": "{fullName} vous a envoyé le cadeau suivant : {gift}. Le cadeau a été ajouté à votre compte et apparaîtra avec les autres offres. N’oubliez pas de l’activer.",
  "acceptOrderModal": "Ayez cette commande prête pour {serviceMode} à {time} le {date}. Vous ne serez pas en mesure de rejeter une commande après l'avoir acceptée ici.",
  "acceptTermsAndPrivacyIntro": "J'accepte la: {privacyPolicyLink}, {rewardsPolicyLink}, {termsOfServiceLink}",
  "account": "Compte",
  "accountDefault": "défaut",
  "accountDetails": "Détails du compte",
  "accountInfo": "Infos sur le compte",
  "accountRewardsPoints": "Tu détiens {points} Couronnes.",
  "accountRewardsPointsExpiration": "{pointsToExpire} Couronnes expireront le {expirationDateTime}",
  "accountWithEmailAlreadyExists": "Un compte avec cette adresse courriel existe déjà ",
  "activate": "Activer",
  "add": "Ajouter",
  "addCreditCard": "Ajouter une Carte de crédit",
  "addCreditDebitCard": "Ajouter Carte de Crédit / Débit",
  "addFavorite": "Ajoute un favori",
  "addItemLabel": "Ajouter 1 {itemName} à votre panier",
  "addItemToCart": "Ajouter {name} au panier",
  "addItemToCartWithModifiers": "Ajouter {name} avec  {modifiers} au panier",
  "addItems": "Ajouter des produits",
  "addItemsLowerCase": "Ajouter des produits",
  "addNewCard": "Carte de débit ou de crédit",
  "addNewPaymentMethod": "Ajouter un mode de paiement",
  "addNewPaymentMethodGiftCard": "Ajoutez carte BK Crown",
  "addOffers": "Ajouter offres",
  "addPayment": "Ajouter carte",
  "addPaymentMethod": "Ajouter carte",
  "addPaymentMethodOrReload": "Ajouter une nouvelle carte",
  "addPrepaidCard": "Ajoutez une carte BK Crown",
  "addQuantityAndItemWithPrice": "Ajouter {quantity} {itemName} à la commande pour {price}",
  "addRewards": "Ajouter recompenses",
  "addToCart": "Ajouter",
  "addToCartCarousel": "Ajouter au panier",
  "addToCartError": "Impossible d'ajouter à la commande. Svp essayer de nouveau.",
  "addToCartSuccess": "{itemName} ajouté au panier.",
  "addToOrder": "Ajouter à la commande",
  "addToOrderHeader": "Ajouter à la commande",
  "addons": "Petis ajouts",
  "address": "Adresse",
  "addressError": "Oups! Adresse non reconnue",
  "addressRequired": "Adresse (Obligatoire)",
  "addressRequiredError": "Vous devez entrer une adresse",
  "adsPersonalization": "Publicité ciblée par centres d’intérêt",
  "adsPersonalizationInfo": "Si cette option est activée, nous pourrions partager vos coordonnées et l’identifiant de votre appareil avec des médias sociaux et d’autres plates-formes de tiers afin de nous aider à diffuser des publicités et des offres susceptibles de vous intéresser, ou en intéresser d’autres. Vous pouvez vous désinscrire à tout moment, mais notez que cela pourrait entraîner des répercussions sur la pertinence des publicités et des offres que vous recevrez. Pour en savoir davantage, veuillez consulter {privacyPolicyLink}.",
  "afterDiscount": "Après réduction",
  "agreeToTermsOfService": "J’accepte les modalités d’utilisation",
  "agreeToTermsOfServiceError": "Vous devez accepter la politique de confidentialité et les conditions d'utilisation avant de vous inscrire.",
  "aliasAutoRenamed": "L'alias sélectionné a déjà été utilisé et a été renommé automatiquement.",
  "aliasError": "Veuillez sélectionner une étiquette (Domicile, Travail ou Autre).",
  "aliasLabelHome": "Domicile",
  "aliasLabelOther": "Autre",
  "aliasLabelWork": "Travail",
  "allRightsReserved": "Tous droits réservés.",
  "allergenInformation": "Renseignements sur les allergènes",
  "allergensDisclaimerContains": "Ce produit contient {allergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerContainsAndMayBeCookedOn": "Ce produit contient {allergens} et être préparé sur les mêmes appareils que {maybeCookedOnAllergens}. Les modifications ne sont pas représentées dans cette liste.",
  "allergensDisclaimerContainsAndMayContain": "Cet article contient {allergens} et peut contenir des traces de {maybeAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerContainsAndMayContainAndMayBeCooked": "Cet article contient {allergens}, peut contenir des traces de {maybeAllergens} et être préparé sur les mêmes appareils que {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerMayBeCookedOn": "Ce produit peut être cuit sur le même équipement utilisé pour cuire ce qui suit : {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerMayContain": "Ce produit peut contenir {maybeAllergens}. Les modifications ne sont pas reflétées dans cette liste.",
  "allergensDisclaimerMayContainAndMayBeCookedOn": "Ce produit peut contenir ce qui suit : {maybeAllergens}. Il peut également être cuit sur le même équipement utilisé pour cuire ce qui suit : {maybeCookedOnAllergens}. Les modifications ne figurent pas dans cette liste.",
  "allergensDisclaimerUnknown": "Ce produit peut contenir des allergènes",
  "amount": "quantité",
  "amountMore": "+{amountMore} autre(s)",
  "and": "et",
  "apartment": "Appartement",
  "appImage": "Image de l'appli",
  "applePay": "Paiement Apple",
  "applePayPaymentNotAvailable": "Nous n’acceptons pas en ce moment les paiements Apple Pay sur nos sites Web. Veuillez sélectionner ou ajouter un nouveau type de paiement.",
  "apply": "Appliquer",
  "aptOrSuite": "Appartement ou bureau",
  "areDeliveryDetailsValid": "Nous ne sommes pas en mesure de confirmer votre numéro de téléphone. Veuillez confirmer que votre numéro de téléphone est correct ou en essayer un autre.",
  "at": "au",
  "attachedToMyCodeSuccess": "{type} liée à Mon Code.",
  "authEmailSentEmail": "Nous avons envoyé un courriel contenant des instructions de connexion à",
  "authError": "Une erreur s'est produite lors de la connexion",
  "authRetryError": "Une erreur s’est produite. Appuyez ci-dessous pour réessayer.",
  "authVerifyWithCode": "Vérifiez avec un code",
  "autoReload": "Réapprovisionnement automatique",
  "autoReloadThreshold": "Lorsque le solde de ma Carte Tim est inférieur à :",
  "autoSignInSuccess": "Félicitations! Votre compte a été créé.",
  "available": "Disponible",
  "availableCrowns": "Couronnes disponibles",
  "availableForDelivery": "Commande pour livraison seulement",
  "availableForPickUp": "Cueillette de commande seulement",
  "availablePoints": "Couronnes disponibles",
  "back": "Précedent",
  "backToMenu": "Retourner au menu",
  "backToOffers": "Retourner aux offres",
  "backToTopics": "Retour aux sujets",
  "backgroundImage": "Image d’arrière-plan",
  "badNetworkDialogBody": "Afin d’accéder à toutes les fonctionnalités de l’appli, veuillez vous déplacer dans une zone où le signal Internet est plus fort et essayez de nouveau.",
  "billingAddressIsSameAsDeliveryAddress": "L’adresse de facturation est la même que l’adresse de livraison.",
  "bk.pypestreamLoadingMessage": "Un moment pendant que nous activons le soutien.",
  "bk_logo_title": "Burger King",
  "bonusPointsLabel": "Couronnes en prime",
  "breakfastDayPartEnds": "Le déjeuner prend fin dans {minutes} min",
  "breakfastDayPartHours": "Déjeuner ofert jusqu’à {endDateHours}",
  "breakfastMenu": "Menu déjeuner",
  "button": "bouton",
  "cal": "cal",
  "calculatingEta": "Calcul de l'emplacement du livreur",
  "calories": "Calories",
  "canada": "Canada",
  "cancel": "Annuler",
  "cancellationPolicy": "Aucun changement ne peut être apporté à votre commande après l’avoir passée.",
  "cancellationPolicyTitle": "Politique d’annulation",
  "cancelledOrderAction": "Nous sommes désolés, mais il semblerait que votre commande a été annulée et remboursée. Si vous voulez passer votre commande à nouveau, vous pouvez utiliser le bouton ci-dessous",
  "cancelledOrderTitle": "Oh non! Votre commande a été annulée.",
  "cannotDeliveryTo": "Actuellement nous ne pouvons pas faire de livraison à ",
  "cannotPlaceOrder": "Nous n'avons pas pu passer votre commande. Fermez ce message pour trouver d'autres restaurants à proximité.",
  "carbohydrates": "Glucides",
  "card": "CARTE",
  "cardAddedNotification": "Carte ajoutée!",
  "cardCurrenciesDontMatch": "La Carte Tim que vous essayez de transférer est d'une région différente de celle de votre compte. Vous ne pouvez transférer que des Cartes Tim provenant de votre région.",
  "cardDeactivationError": "Nous n'avons pas pu traiter votre demande. Veuillez réessayer ou appuyer sur {link} pour obtenir de l'aide.",
  "cardExpiration": "Date d'expiration de la carte",
  "cardNumber": "Numéro de carte",
  "cardNumberIsRequired": "Vous devez entrer le numéro de la carte",
  "cardNumberRequiredError": "Vous devez entrer le numéro de la carte",
  "cardXHasABalanceOfY": "La carte {cardNumber} a un solde de {balance}.",
  "careers": "Carrières",
  "cart": "Panier",
  "cartCardLoadingMessage": "Nous préparons ta commande…",
  "cartOfferRequirementsNotMetError": "Les articles de votre panier ne répondent pas aux exigences de cette offre",
  "cartV2_incentiveFeedbackSubtotal": "Un achat minimum de {targetValue} $ est requis",
  "cash": "Argent",
  "ccNumberIsNotValid": "Le numéro de la carte n'est pas valide",
  "celery": "céleri",
  "challenge": "Défi",
  "challengeStarted": "Le défi est lance",
  "change": "Changer",
  "changeRedemptionToInStore": "Êtes-vous certain de vouloir passer à une réclamation en restaurant?",
  "changeRedemptionToInStoreConfirmLabel": "Passer à en restaurant",
  "changeRedemptionToInStoreDescription": "Votre panier sera supprimé si vous passez à une réclamation en restaurant. Souhaitez-vous vraiment continuer?",
  "changeRedemptionToPickUp": "Êtes-vous certain de vouloir passer à une commande mobile?",
  "changeRedemptionToPickUpConfirmLabel": "Passer à une commande mobile",
  "changeRedemptionToPickUpDescription": "En passant d’une réclamation en restaurant à une commande mobile, vous supprimerez vos récompenses actives. Voulez-vous procéder?",
  "changeRestaurantDialogBody": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles.",
  "changeRestaurantDialogConfirmButtonLabel": "Changer Restaurant",
  "changeRestaurantDialogHeading": "Changer Restaurant?",
  "changeServiceMode": "Modifier le mode de service",
  "changeStoreMessage": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles. Voulez-vous poursuivre avec le changement de restaurant?",
  "changeStoreMessagePromptDisclaimer": "Changer le restaurant pourrait entraîner des changements aux prix et produits disponibles.",
  "changeStores": "Changer le restaurant",
  "checkNetworkSettings": "Veuillez vérifier vos paramètres réseau et réessayer",
  "checkout": "Caisse",
  "checkoutPaymentMethodNeedRevaultError": "Une erreur s’est produite lors du traitement de votre mode de paiement. Veuillez rajouter votre mode de paiement.",
  "cholesterol": "Cholestérol",
  "chooseDifferentItem": "Veuillez sélectionner un autre produit.",
  "chooseDifferentOffer": "Veuillez sélectionner une autre offre.",
  "chooseDrink": "Ensuite, choisissez une boisson",
  "chooseItemAmount": "Choisissez {amount} {itemName}",
  "chooseSide": "Ensuite, choisissez un accompagnement",
  "chooseYourLocation": "Choisir un resto",
  "city": "Ville",
  "cityRequiredError": "Vous devez entrer une ville",
  "clearFilter": "supprimer filtre",
  "clearText": "Effacer le texte",
  "clickHereForDetails": "Cliquez ici pour plus de détails",
  "clickToSelectLocation": "Sélectionner le restaurant",
  "close": "Fermer",
  "closed": "Fermé",
  "closesAt": "Ferme à {time}",
  "closestStoreSelected": "Nous avons sélectionné le restaurant le plus près de votre emplacement actuel.",
  "codeErrorMessage": "Impossible de récupérer votre code.",
  "comboOfferSavings": "Économies",
  "comments": "Commentaires",
  "communicationPreferences": "Préférences de communication",
  "completed": "Terminé",
  "confirm": "confirmez",
  "confirmDeletePaymentMethod": "Êtes-vous sûr de vouloir supprimer ce mode de paiement?",
  "confirmDialogBody": "Veuillez continuer si vous êtes prêt à réclamer au restaurant",
  "confirmYourStore": "Confirmez votre restaurant",
  "confirmationDifferentLocation": "Choisissez une autre adresse",
  "contact": "Contacter",
  "contactCourier": "Vous pouvez contacter votre livreur au:",
  "contactSupport": "Contacter Le Service D'Assistance",
  "containsAllergens": "Contient: {allergens}",
  "continue": "Continuer",
  "continueCustomizing": "Continuer à personnaliser",
  "continueEditing": "Continuer à modifier",
  "continueToCart": "Continuer au panier ({numberOfItemsInCart})",
  "continueWithEmail": "Accès par Courriel",
  "copy": "Copier",
  "couldNotLocateStore": "Il est impossible de localiser le restaurant pour compléter votre commande. Veuillez réessayer plus tard.",
  "couldntProcessOrder": "Veuillez essayer de passer votre commande au restaurant et fournir votre code à 6 chiffres, ou sélectionnez un autre restaurant.",
  "country": "Pays",
  "couponWillExpire": "Ce bon expirera dans 15 minutes",
  "createAccountHeadline": "Créez un compte pour commencer",
  "createAnAccount": "Créer un compte",
  "createAnAccountErrors": "Le formulaire a {count, plural, one {# erreur} other {# erreurs}}.",
  "createAnAccountSubheader": "Bienvenue! Vous créez un compte lié à {email}",
  "credit": "Crédit",
  "creditCardExpired": "Le numéro de carte de crédit est expiré",
  "creditCardNumber": "Numéro de carte ",
  "crowns": "Couronnes",
  "crownsAllYours": "Ça fait {points} Couronnes — à toi !",
  "crownsAwayFromUnlockingMoreRewards": "Couronnes avant de déverrouiller d’autres récompenses",
  "crownsEarned": "{points} Couronne{points, plural, one {} other {s}} Obtenue{points, plural, one {} other {s}}",
  "crownsEarnedKeepGoing": "{crowns} couronnes gagnées — continuez !",
  "curbside": "Pickup à l'extérieur",
  "curbsideHours": "Heures d'ouverture pickup à l'extérieur",
  "curbsideVehicleDescription": "Aidez-nous à vous trouver en décrivant votre véhicule; p. ex. VUS rouge. À votre arrivée au restaurant, trouvez un endroit pour vous stationner. Dès que votre commande sera prête, nous vous l’apporterons.",
  "curbsideVehicleDescriptionPlaceholder": "Description du véhicule",
  "currentServiceModeUnavailable": "Le restaurant n'accepte pas de commandes {serviceMode} en ce moment. Changez le mode de service ou sélectionnez un autre établissement",
  "customizations": "Personnalisations",
  "cvv": "CVV",
  "cvvIsRequired": "Le numéro CVV est requis",
  "cvvMustBeAtLeast3Digits": "Le code CVV doit comporter au moins 3 chiffres",
  "date": "Date",
  "dateOfBirth": "Date de naissance",
  "dateOfBirthIsBelowMinimum": "Les informations renseignées ne sont pas en conformité avec nos {termsLink} et notre {privacyPolicyLink}",
  "dateOfBirthIsRequired": "La date de naissance est un champ obligatoire.",
  "day": "Jour",
  "dayPlaceholder": "JJ",
  "daypartAfterEndTime": "La période {dayPart} est terminée!",
  "daypartEndsAt": "{dayPart} se termine à {endTime}",
  "daytime": "Pendant la journée",
  "daytimeMenu": "Menu du jour",
  "daytimeMenuHeader": "De {daytimeStartTime} à {daytimeEndTime}",
  "daytimeMenuHeaderHours": "De {daytimeStartTime} à la fermeture",
  "declineReason": "Decline reason",
  "delete": "supprimer",
  "deleteAccount": "Supprimer le compte",
  "deleteButtonText": "Supprimer",
  "deletePaymentMethod": "Supprimer le mode de paiement",
  "deliverHere": "Livrer ici",
  "deliverTo": "Livrer à",
  "delivered": "Livré",
  "deliveringTo": "Livrer à",
  "deliveringToYourDoorAt": "Livraison à votre porte au",
  "delivery": "Livraison",
  "deliveryAddNewAddress": "Ajouter une nouvelle adresse",
  "deliveryAddress": "Adresse de livraison",
  "deliveryAddressFormatted": "{addressLine1}, {city}, {state} {zip}",
  "deliveryCheckingMessage": "Nous cherchons quel restaurant livrera à votre adresse. Attend quelques instants...",
  "deliveryClosed": "Livraison fermée. Sélectionnez une autre adresse",
  "deliveryClosing": "La livraison se termine dans {minutes} min",
  "deliveryDelivered": "Livrée",
  "deliveryDetails": "Détails de la livraison",
  "deliveryDetailsInstructions": "Directives de livraison",
  "deliveryDriverEnroute": "Livreur en route",
  "deliveryFee": "Frais de livraison",
  "deliveryFeeDescription": "Les frais de livraison varient pour chaque restaurant en fonction de votre emplacement et d'autres facteurs.",
  "deliveryFees": "Frais de commande de livraison",
  "deliveryFeesStripeTitle": "Des frais de livraison s’appliquent",
  "deliveryFeesStripeTitleSuffix": "Commande minimale de {amount}",
  "deliveryImage": "Image de livraison",
  "deliveryInfo": "Renseignements sur la livraison",
  "deliveryInstructions": "Directives de livraison",
  "deliveryMinumumNotReached": "Nous sommes désolés! Le montant minimal pour une commande de livraison est de {min}",
  "deliveryNotAvailable": "Livraison indisponible",
  "deliveryOrder": "Commande en Livraison",
  "deliveryOrderBeingPrepared": "En préparation",
  "deliveryOrderPlaced": "Commande passée pour livraison",
  "deliveryPhoneDisclosure": "Votre numéro de téléphone est nécessaire afin de nous permettre de vous acheminer les mises à jour liées à votre commande et de faciliter la communication entre vous et votre livreur. Notez que votre numéro de téléphone ne pourra être vu par le livreur.",
  "deliverySelectYourAddress": "Sélectionnez votre adresse de livraison",
  "deliveryShouldSaveInfoCheckboxMessage": "Sauvegardez mes informations afin de me permettre de recevoir des mises à jour sur ma commande et des communications de la part du livreur. Le livreur ne verra pas votre numéro de téléphone.",
  "deliveryStatusDriverAssigned": "Votre commande est en cours",
  "deliveryStatusDriverAtCustomer": "Votre livreur n’est pas loin!",
  "deliveryStatusDriverAtStore": "Votre livreur vient de ramasser votre commande ",
  "deliveryStatusDriverStarting": "Votre livreur ramasse votre commande",
  "deliveryStatusDriverUnassigned": "Votre commande est en cours",
  "deliveryStatusOrderAbandoned": "Votre commande a été livrée",
  "deliveryStatusOrderCancelled": "Votre commande a été annulée",
  "deliveryStatusOrderCreated": "Votre commande est en cours",
  "deliveryStatusOrderDroppedOff": "Votre commande a été livrée",
  "deliveryStatusOrderError": "Erreur lors du traitement de votre commande",
  "deliveryStatusOrderPickedUp": "Votre livreur est en route!",
  "deliveryStatusOrderTimeout": "Temps de traitement de la commande expiré",
  "deliveryStatusQuoteError": "Erreur lors du traitement de votre commande",
  "deliveryStatusQuoteRequested": "On est en train de traiter votre commande",
  "deliveryStatusQuoteSuccessful": "Nous avons reçu votre commande",
  "deliveryStatusQuoteUnavailable": "On ne peut pas traiter votre commande",
  "deliveryTerms.ca.heading": "Frais de livraison au Canada :",
  "deliveryTerms.ca.mobileTitle": "Conditions générales de commande et de paiement mobile",
  "deliveryTerms.caFeeValue": "3,00 $",
  "deliveryTerms.californiaHeading": "Californie :",
  "deliveryTerms.coloradoHeading": "Colorado:",
  "deliveryTerms.fee.ca.gte12.label": "Livraison sur les commandes ≥12$ :",
  "deliveryTerms.fee.ca.gte12.value": "Frais de livraison de 2,99 $ + Frais de service de 10 %",
  "deliveryTerms.fee.ca.lt12.label": "Livraison sur les commandes <12$ :",
  "deliveryTerms.fee.ca.lt12.value": "Frais de livraison de 2,99 $ + Frais de service de 10 % + Frais de petit panier de 1,99 $",
  "deliveryTerms.feeLabel": "Frais de livraison :",
  "deliveryTerms.feeValue": "2,99 $ (0 $ pour les commandes de 25 $ et plus)",
  "deliveryTerms.intro": "Livraison proposée dans les restaurants participants aux États-Unis sur l'application BK et bk.com. Commande minimale de 5 $ requise (avant taxes et frais). Prix plus élevés qu'en restaurant. L'inscription à un compte BK est nécessaire. Livraison assurée par des fournisseurs de livraison tiers, sous réserve de disponibilité et des heures de livraison du restaurant. Les coupons imprimés ne sont pas valables pour les commandes de livraison. Toutes les offres numériques ne sont pas disponibles en livraison. Vérifiez les conditions des offres numériques sur bk.com/offers avant de commander. Les frais sont basés sur le sous-total de la commande.",
  "deliveryTerms.intro.ca.part1": "Livraison offerte dans les restaurants canadiens participants sur l'application BK et burgerking.ca. Livraison assurée par des fournisseurs de livraison tiers, sous réserve de disponibilité et des heures de livraison du restaurant.",
  "deliveryTerms.intro.ca.part2": "Les prix peuvent être plus élevés que dans les restaurants. Frais de commande de livraison : des frais de livraison, des frais de service et des frais pour petits paniers peuvent s'appliquer.",
  "deliveryTerms.intro.ca.part3": "Les coupons imprimés ne sont pas valables pour les commandes à livrer. Certaines offres numériques ne sont pas disponibles pour la livraison. Consultez les conditions des offres numériques sur burgerking.ca/rewards/offers avant de commander.",
  "deliveryTerms.retailFeeLabel": "Frais de livraison au détail du Colorado :",
  "deliveryTerms.retailFeeValue": "Des frais de livraison de 0,29 $ sont exigés par la loi pour les livraisons dans l'État du Colorado",
  "deliveryTerms.serviceFeeLabel": "Frais de service :",
  "deliveryTerms.serviceFeeValue": "15% du sous-total de la commande",
  "deliveryTerms.smallCartLabel": "Frais de petit panier :",
  "deliveryTerms.smallCartValue": "2,50 $ pour les commandes de moins de 10 $",
  "deliveryTerms.statesHeading": "Tous les états (sauf la Californie et le Colorado) :",
  "deliveryTerms.title": "Livraison sur l'application BK et sur bk.com",
  "deliveryTerms.title.ca": "Livraison sur l'application BK et burgerking.ca",
  "deliveryTermsHeading": "Conditions de livraison",
  "deliveryTermsPrefix": "Les conditions et frais de livraison s'appliquent. Les prix peuvent être plus élevés que dans les restaurants.",
  "deliveryTime": "Heure de livraison",
  "describeIssue": "Décrivez votre problème",
  "describeIssueAndIncludePhoneNumber": "Décrivez votre problème (veuillez inclure votre numéro de téléphone)",
  "describeYourVehicle": "Décrivez votre véhicule",
  "descriptionLengthError": "La longueur de la description doit être entre {min} et {max} caractères.",
  "details": "Détails",
  "deviceSettings": "Paramètres du dispositif",
  "diagnostics": "Diagnostique",
  "dialog": "dialogue",
  "didNotReceiveCodeHeading": "N’a pas reçu un code?",
  "differentDeviceError": "Nous avons remarqué que cet appareil n’est pas celui duquel vous avez demandé ce code. Pour ouvrir une session sur cet appareil, veuillez demander un nouveau code ci-dessous.",
  "dineIn": "En restaurant",
  "dineInAt": "Dîner à",
  "dineInHours": "Heures d'ouverture de la salle à manger",
  "dineInOrder": "Commande en restaurant",
  "dineInOrderPlaced": "Commande salle à manger passée",
  "directions": "Directives",
  "discard": "Supprimer",
  "discardChanges": "Annuler les modifications.",
  "distance": "Milles",
  "done": "Terminé",
  "driveThru": "Service au volant",
  "driveThruAt": "Service au volant à",
  "driveThruHours": "Heures d'ouverture du service au volant",
  "driveThruMobileOrderPlaced": "Commande mobile passée pour service au volant",
  "driveThruOrder": "Commande pour le service au volant",
  "driveThruOrderPlaced": "Commande passée au service au volant",
  "duplicateSupportFormSubmission": "Une fiche a déjà été créée concernant votre problème. Veuillez patienter jusqu'à 48 heures pour recevoir une réponse.",
  "earned": "Vous avez obtenu",
  "eatIn": "En restaurant",
  "edit": "Modif.",
  "editAddress": "Modifier l'adresse",
  "editAddressFailed": "Impossible de mettre à jour l'adresse. Veuillez réessayer.",
  "eggs": "œufs",
  "email": "Courriel",
  "emailAddress": "Adresse électronique",
  "emailPushPreferencesDescription": "Soyez le premier à découvrir les nouveaux produits au menu et nos offres alléchantes.",
  "emailPushPreferencesTitle": "Mises à jour et offres",
  "emailRequiredError": "L'adresse courriel est un champ obligatoire.",
  "emailVerificationSent": "Courriel envoyé! Veuillez vérifier votre e-mail pour le lien de vérification.",
  "enableLocationServices": "Activez les services de localisation",
  "enablePushNotificationsOnDevice": "Afin de recevoir des notifications de Burger King, vous devez d’abord activer les notifications dans les paramètres de votre appareil.",
  "endsIn": "••••",
  "endsInRedesign": "*",
  "enterReceiptCode": "Entrer le code pour gagner",
  "errorBoundaryBody": "Nous éprouvons un problème. Consultez notre menu et nos offres pendant que nous tentons de le résoudre.",
  "errorBoundaryTitle": "Dommage!",
  "errorCreatingSupportCase": "Une erreur s'est produite lors de la soumission de votre dossier d'assistance. Veuillez réessayer",
  "errorDialogCooldownMessage": "Nous préparons en ce moment une commande similaire pour vous. Êtes-vous certain de vouloir commander de nouveau?",
  "errorDialogCooldownTitle": "Commande en cours",
  "errorDialogFavoriteStoreMessage": "Pour programmer votre restaurant favori, inscrivez-vous ou ouvrez une session dans votre compte.",
  "errorDialogFavoriteStoreTitle": "Ouverture de session requise",
  "errorProcessingRequest": "Il semble qu'une erreur s'est produite lors du traitement de votre demande.",
  "errorRetrievingRestaurants": "Impossible de trouver les restaurants",
  "eta": "Délai de livraison prévu",
  "etaFull": "Délai de livraison prévu",
  "exceedsBalanceLimit": "Ce montant dépasse votre solde",
  "exceedsRewardsBalance": "Si vous ajoutez cette récompense à votre panier d’achats, vous surpasserez votre solde de Couronnes actuel. Veuillez retirer les Couronnes de votre panier d’achats.",
  "exitDeliveryAddressMessage": "Quitter l'adresse de livraison avec des modifications non enregistrées",
  "expirationDate": "Date d'expiration",
  "expirationDateIsRequired": "La date d'expiration est requise",
  "expire": "exp.",
  "expired": "Expirée",
  "expiredCard": "Carte expirée",
  "expiring": "qui expirent le",
  "expiringWithDate": "qui expirent {expiringDate}.",
  "faq": "Foire aux questions",
  "fat": "Gras",
  "favorite": "Favoris",
  "favoriteRemoveAllModalBody": "Retirer tous les produits de cette commande supprimera votre favori. Voulez-vous vraiment supprimer cette commande?",
  "favoriteRemoveAllModalHeader": "Attendez! Vous n'avez sélectionné aucun produit!",
  "fees": "Frais",
  "feet": "pieds",
  "fetchCoordinatesError": "Nous n'avons pas pu trouver les coordonnées pour l'adresse sélectionnée. Veuillez réessayer.",
  "fiber": "Fibre",
  "filter": "filtre",
  "filterByMonth": "Filtrer par mois",
  "filters": "filtres",
  "findARestaurant": "Trouver un restaurant",
  "finishOrder": "Terminer la commande",
  "finishYourProfile": "Complétez votre profil",
  "firstName": "Prénom",
  "fish": "poisson",
  "forItemAvailability": "Disponibilité",
  "forterSignUpError": "Il semble que vous détenez déjà un compte avec nous. Veuillez accéder à votre compte existant ou communiquez avec notre Service de soutien pour obtenir de l’aide.",
  "foundation": "Fondation",
  "free": "Gratuit",
  "freeDeliveryOverAmount": "Livraison gratuite pour les commandes de plus de {amount}",
  "friday": "Vendredi",
  "from": "De",
  "fullMenu": "Menu complet",
  "futureDateOfBirthProvided": "La date de naissance ne peut pas être ultérieure à la date d'aujourd'hui.",
  "giftCard": "Carte Cadeau",
  "giftCardAddingError": "Il se peut que les données de la carte cadeau soient inexactes ou qu'il y ait un problème avec votre carte, veuillez réessayer plus tard ou contacter l'émetteur.",
  "giftCardExists": "La carte cadeau existe déjà dans les méthodes de paiement. Vous ne pouvez avoir qu'une seule carte cadeau dans vos méthodes de paiement.",
  "giftCardNumber": "Numéro de la carte Crown",
  "giftCardNumberIsNotValid": "Le numéro de la carte cadeau n'est pas valide",
  "giftCardNumberIsRequired": "Le numéro de la carte cadeau est requis",
  "gluten": "gluten",
  "googlePay": "Google Pay",
  "grabYourReward": "Réclamez votre récompense !",
  "hamburgerMenuAriaLabel": "Naviguer vers le menu Compte",
  "haveItYourWay": "Toujours à ton goût",
  "here": "ici",
  "hiX": "Bonjour {name}",
  "higherPricesWarning": "Prix en hausse possible",
  "history": "historique",
  "historyTab": "Historique",
  "historyTitle": "Historique",
  "home": "Accueil",
  "homepage": "Page D'accueil",
  "hours": "Heures",
  "hoursOfOperationFallbackMessage": "Fermé",
  "howItWorks": "Comment ça fonctionne",
  "howToRedeem": "Comment réclamer l'offre",
  "howWouldYouLikeToReceiveThisOrder": "Comment souhaitez-vous recevoir cette commande?",
  "imCraving": "J’ai une fringale de",
  "image": "image",
  "inRestaurantOrder": "Commande en restaurant",
  "incentiveFeedbackCartRequirement": "Ajoutez les produits requis à votre panier d’achats afin d’effectuer une réclamation.",
  "incentiveFeedbackCartRequirementExclusion": "Ne peut être jumelée à :",
  "incentiveFeedbackDefault": "Votre panier d’achats ne répond pas aux exigences permettant de réclamer cette {incentiveType}.",
  "incentiveFeedbackExpired": "Cette offre prend fin le {endDate}.",
  "incentiveFeedbackInvalidDay": "Cette offre n’est valide que le {targetValue}.",
  "incentiveFeedbackInvalidStore": "Cette {incentiveType} n’est pas valide au restaurant que vous avez sélectionné.",
  "incentiveFeedbackInvalidTime": "Cette {incentiveType} n’est valide qu’entre {startTime} et {endTime}. Revenez à {startTime} pour profiter de l’offre!",
  "incentiveFeedbackMaxRedemptions": "Vous avez surpassé votre nombre de réclamations permis pour cette {incentiveType}.",
  "incentiveFeedbackNotAvailableInStore": "Non disponible dans ce restaurant",
  "incentiveFeedbackOfferNotAvailable": "Désolés, mais cette offre n’est plus disponible.",
  "incentiveFeedbackOutOfDayPart": "Non disponible en ce moment. Veuillez revenir plus tard!",
  "incentiveFeedbackOutOfDayPartTime": "Disponible dès {time}",
  "incentiveFeedbackPaymentMethod": "Vous devez payer avec {targetValue} afin de réclamer cette {incentiveType}.",
  "incentiveFeedbackServiceMode": "Cette {incentiveType} n’est disponible que pour les {targetValue}.",
  "incentiveFeedbackSubtotal": "Votre total partiel doit s’élever à {targetValue} $ pour réclamer cette {incentiveType}. Ajoutez {calculatedValue} $ pour la réclamer.",
  "incentiveFeedbackWithinCooldown": "Vous avez récemment utilisé cette offre. Vous pourrez en utiliser une autre {calculatedValue} minutes.",
  "included": "Inclus",
  "info": "Info",
  "information": "Information",
  "instructions": "Instructions",
  "instructionsPlaceholder": "Indiquez au livreur où il doit déposer la commande",
  "instructionsTooLong": "Les instructions doivent comporter moins de 200 caractères.",
  "insufficientBalanceReloadAgain": "Solde prépayé insuffisant – veuillez réapprovisionner votre carte pour passer au paiement.",
  "invalidDateMissingFields": "Date non valide: {count, plural, one {Le champ} other {Les champs}} {missingFields} {count, plural, one {est requis} other {sont requis}}",
  "invalidDateOfBirthProvided": "La date de naissance fournie n'est pas valide",
  "invalidEmail": "Courriel Non Valide",
  "invalidInstructions": "Les instructions contiennent des caractères non pris en charge.",
  "invalidOfferError": "Votre offre n’est pas valide.",
  "invalidOtpProvided": "Le code que vous avez entré ne correspond pas à celui que nous vous avons envoyé. Veuillez vérifier vos messages et réessayer.",
  "invalidPaymentMethodError": "Votre mode de paiement n’est pas valide. Veuillez essayer un autre mode de paiement.",
  "invalidPhoneNumberFormat": "Format de numéro de téléphone invalide. Veuillez saisir un numéro valide.",
  "invalidReloadError": "Nous n’avons pas pu réapprovisionner votre carte.",
  "invalidTipAmountError": "Veuillez soumettre un montant de pourboire valide.",
  "issueWithMyItems": "Un problème avec mon/mes article(s)",
  "issuesDuringExperience": "Si vous avez eu des problèmes durant le processus de commande,",
  "item": "Produit",
  "itemAddedToCart": "1 {itemName} a été ajouté(e) à votre panier.",
  "itemFavorited": "Élément sauvegardé dans les favoris!",
  "itemFavoritedError": "Oups! Une erreur s’est produite avec votre favori. Veuillez réessayer plus tard.",
  "itemNotAvailable": "Produit non disponible",
  "items": "Produits",
  "itemsUnavailable": "Produits non disponibles",
  "justMoreToReachNextLevel": "Juste {points} de plus pour atteindre le niveau suivant",
  "keepAddress": "Conserver l'adresse",
  "keepCurrentLocation": "Sauvegarder le choix de restaurant",
  "kilometers": "km",
  "languageAndRegion": "Langue et Région",
  "languageAndRegionSelector": "Sélection de la langue et de la région",
  "learnMore": "En savoir plus",
  "leaveNow": "Quitter maintenant",
  "leaveWithoutSaving": "Quitter sans sauvegarder",
  "left": "Reste",
  "legal": "Légal",
  "letsGetStarted": "C’est parti, {userName} !",
  "limitReached": "Limite atteinte",
  "linkOpensInNewTab": "Le lien s'ouvre dans un nouvel onglet",
  "list": "Liste",
  "listOfWordsLayout": "{position, select, first {} last { et } other {, }}{word}",
  "listOfWordsLayoutOr": "{position, select, first {} last { ou } other {, }}{word}",
  "listbox": "zone de listes",
  "loadMore": "Charger plus",
  "loadWith": "Approvisionner avec",
  "loadingYourOrder": "Chargement de votre commande",
  "localeDateTime": "fr-CA",
  "location": "Emplacement",
  "logIn": "Connexion",
  "logInWithApple": "Continuer avec Apple",
  "logInWithExistingEmail": "Un compte est déjà associé à cette adresse courriel. Aimeriez-vous plutôt ouvrir une session?",
  "logInWithGoogle": "Continuer avec Google",
  "logo": "Logo de BK",
  "looksLikeWereExperiencingIssues": "Il semble qu’un problème s’est produit. Veuillez réessayer!",
  "lostNetworkConnectivity": "Il semble que vous ayez perdu votre connexion réseau",
  "loyaltyCardImage": "Image de la carte FidéliTim",
  "loyaltyCreateAccountHeadline": "Créez un compte pour commencer à",
  "loyaltyHistorySignUp": "Inscrivez-vous ou connectez-vous afin de réclamer et d’obtenir vos récompenses et d’accéder à l’historique de vos Couronnes",
  "loyaltyInfoImage": "Image de l'info sur la carte FidéliTim",
  "loyaltyPoints": "Vous avez {points} Couronnes",
  "loyaltyRewards": "Récompenses Fidélité",
  "loyaltyUnavailableInRegionOops": "Oups!",
  "lupin": "lupin",
  "main": "accueil",
  "mainMenu": "Menu",
  "maintainYourPoints": "Assurez-vous de faire un achat afin de maintenir votre solde de couronnes actif.",
  "map": "Carte",
  "maxAttemptsReached": "Vous avez atteint le nombre maximal de tentatives de connexion permises.",
  "maxAttemptsReachedRequestNewCode": "Vous avez atteint la limite de tentatives d’ouverture de session; veuillez demander un nouveau code ci-dessous.",
  "mayContainAllergens": "Peut contenir: {allergens}",
  "mayContainAllergensViaSharedEquipment": "Peut contenir via un équipement partagé: {allergens}",
  "media": "Médias",
  "menu": "Menu",
  "menuAcceleratorCartMessage": "Délicieusement récompensé — {points} Couronnes à l’horizon!",
  "menuAcceleratorReviewOrderMessage": "Bon choix! Tu obtiendras {points} Couronnes pour cette commande.",
  "message": "Message",
  "messageAllowLocation": "Veuillez autoriser la communication de votre emplacement dans les paramètres",
  "meters": "m",
  "method": "Mode: {serviceMode}",
  "miles": "milles",
  "milk": "lait",
  "min": "reste",
  "minimumPriceError": "La valeur de votre panier est inférieure au total requis pour la commande.",
  "minutes": "minutes",
  "mobile": "Cellulaire",
  "mobileOrderDriveThruOrder": "Commande mobile au service au volant",
  "mobileOrderLane": "Commande mobile au service au volant\n",
  "mobileOrderingAndPickup": "Commande mobile et cueillette",
  "mobileOrderingUnavailable": "La commande mobile n'est pas disponible",
  "mobilePickupVehicleDescription": "Aide-nous à te trouver rapidement en identifiant ton véhicule",
  "mobilePickupVehicleDescriptionPlaceholder": "Couleur et marque de ton véhicule",
  "mobilePickupVehicleTitle": "Description du véhicule",
  "mode": "Mode",
  "monday": "Lundi",
  "month": "Mois",
  "monthPlaceholder": "MM",
  "more": "Plus",
  "moreInfo": "Autres renseignements",
  "moreItems": "{remainingItems, plural, =0 {} other {{remainingItems}}} {remainingItems, plural, =0 {} one {autre produit…} other {autres produits…}}",
  "mustAddPaymentMethod": "Ajouter un mode de paiement",
  "mustard": "moutarde",
  "myAccount": "Mon compte",
  "name": "Nom",
  "nameOnCard": "Nom sur la carte",
  "nameOnCardIsRequired": "Vous devez entrer le nom apparaissant sur la carte",
  "nameRequiredError": "Le nom est un champ obligatoire.",
  "nameYourFavorite": "Nommez le favori",
  "nativePaymentNotAvailable": "Nous n’acceptons pas Google Pay ni Apple Pay sur nos sites Web à l’heure actuelle. Veuillez choisir ou ajouter un autre mode de paiement.",
  "navHome": "Accueil",
  "navMenu": "Menu",
  "navMyCode": "Mon Code",
  "navOffers": "Offres",
  "navRewards": "Couronnes",
  "nearby": "À proximité",
  "needHelp": "Vous avez besoin d’aide?",
  "needMoreHelpSendUsAMessage": "Encore besoin d'aide ? Envoyez-nous un message",
  "new": "Nouveau",
  "newCodeSent": "Un nouveau code a été envoyé à votre courriel!",
  "newExclame": "Nouveauté!",
  "next": "Suivant",
  "nextCustomize": "Suivant, Personnalisez",
  "nextReviewYourMeal": "Suivant, vérifie ton repas",
  "nextReviewYourSelection": "Suivant, vérifie ta sélection",
  "nextSelectYourDrink": "Suivant, choisis ta boisson",
  "nextSelectYourSide": "Suivant, choisis ton accompagnement",
  "niceWork": "Bravo, {userName} ! Vous avez gagné",
  "no": "Non",
  "noCourierName": "Nom indisponible",
  "noCourierPhone": "Non disponible",
  "noDirectPayAndNoPrepaidMethodError": "Nous ne sommes pas en mesure d'accepter votre paiement pour le moment. Veuillez réessayer plus tard.",
  "noFavoritesHeader": "Favoris",
  "noFavoritesSubheader": "Sauvegardez un produit de votre panier ou des récents dans les favoris.",
  "noInternetConnection": "Pas de connexion Internet",
  "noItemsFitCriteria": "Aucun produit ne correspond à vos critères de recherche",
  "noLocationsMatchYourSearch": "Aucun emplacement ne correspond à votre recherche.",
  "noOrdersItemsYet": "LES COMMANDES RÉCENTES ET LES PRODUITS SERONT AFFICHÉS ICI",
  "noPaymentMethodOnFile": "Vous n'avez pas de mode de paiement en dossier.",
  "noRecentItemsHeader": "Aucun élément récent pour le moment",
  "noRecentItemsSubheader": "Passez une commande pour voir vos articles récents ici.",
  "noThankYou": "Non merci",
  "nonAvailableItemInStore": "Ce produit n’est pas disponible actuellement à votre restaurant sélectionné.",
  "nonAvailableOfferUntil": "Ce bon n'est pas valable avant {time}. Veuillez réessayer plus tard!",
  "notAvailableAtStore": "Non disponible au restaurant sélectionné",
  "notValidEmailError": "Cela ne ressemble pas à une adresse courriel valide.",
  "notValidPhoneNumberError": "Cela ne semble pas être un numéro de téléphone valide.",
  "notifications": "Notifications",
  "now": "Maintenant",
  "numberOfCrowns": "{crowns} Couronnes",
  "nutritionCommitment": "Chez Burger King, nous nous engageons à servir à nos clients de délicieux aliments préparés avec des ingrédients de toute première qualité. Nos sandwichs Whopper emblématiques, faits de bœuf pur à 100 % et servis avec des garnitures fraîchement tranchées, sont un exemple concret de cette promesse. Dans nos restaurants, où tout est toujours préparé au goût de chaque client, nous innovons constamment afin de réaliser de savoureuses recettes incluant des ingrédients qui leur inspirent confiance.",
  "nutritionalInformationAndAllergen": "Renseignements nutritionnels et sur les allergènes",
  "offer": "Offre",
  "offerAddedToCart": "L’offre a été ajoutée au panier",
  "offerApplied": "Offre appliquée",
  "offerAppliedSuccess": "L’offre a été retirée de votre commande",
  "offerConfirmDialogBody": "Si vous fermez cet écran, le bon sera considéré comme ayant été échangé. Êtes-vous sûr?",
  "offerConfirmDialogConfirmLabel": "Continuer",
  "offerConfirmDialogHeading": "Vous avez terminé?",
  "offerExpires": "Expire le {date}",
  "offerNotApplied": "Offre non appliquée",
  "offerNotAvailable": "Offre non disponible",
  "offerNotAvailableInRestaurantPos": "L’un des produits sélectionnés n’est pas offert à ce restaurant.",
  "offerTerms": "Modalités de l'offre",
  "offers": "Des offres",
  "offersCooldownDescription": "Les offres seront de nouveau disponibles dans {minutes} minutes.",
  "offersCooldownInfo": "Limite d’une offre par visite. Toutes les autres offres seront non disponibles pendant {period} minutes",
  "offersCooldownTitle": "Vous venez de réclamer une offre",
  "offersDisclaimer": "Un(e) par client. Pas de substitutions. N'est pas valable pour des livraisons ou avec d'autres coupons ou offres. Disponible uniquement auprès des établissements qui participent à US Popeyes® (sauf AK & HI). Annuler si interdit ou reproduit ou modifié ou transféré.  Sujet à taxes. Montant liquide de 1/100¢. TM & © 2021 PLKI. Tous droits réservés. Expire le {deactivationDate}",
  "offersNoOffersAvailable": "Aucune offre n'est disponible",
  "offersYouCanStillEnjoyYourFavorites": "Vous pouvez toujours commander vos produits favoris en commandant du menu.",
  "ok": "Ok",
  "okay": "Ok",
  "okayButtonText": "OK",
  "oneOfferPerOrder": "Une seule offre par commande",
  "only": "seulement",
  "oopsComeBackTomorrow": "Oups! Reviens demain à {storeTime} ou sélectionne un autre restaurant.",
  "oopsSomethingWentWrong": "Oups, quelque chose s'est mal passé",
  "open": "Ouvert",
  "open24Hours": "Ouvert 24 heures",
  "openDeviceSettings": "Accédez à vos paramètres",
  "option": "option",
  "optionalInformation": "Informations facultatives",
  "or": "ou",
  "order": "Commander",
  "orderCancelled": "Commande annulée",
  "orderCompleted": "Commande complétée!",
  "orderConfirmation": "Confirmation de la commande",
  "orderConfirmationInstructionsConfirmed": "Nou préparons votre commande et elle sera déposée au comptoir avant dès qu’elle sera prête.",
  "orderConfirmationInstructionsDelivery": "Nous préparons votre commande et elle sera livrée à votre adresse dès qu’elle sera prête.",
  "orderConfirmationInstructionsDriveThru": "Conduisez jusqu’à l’écran des commandes et dites-nous que vous avez commandé en ligne pour {userName}.",
  "orderConfirmationInstructionsMobileDriveThru": "Rendez-vous en voiture à la voie réservée aux commandes mobiles et nous vous apporterons votre commande.",
  "orderConfirmationInstructionsTakeOut": "Nous préparons votre commande et elle sera déposée au comptoir avant dès qu'elle sera prête.",
  "orderConfirmationNumber": "Commande n° {orderNumber}",
  "orderDate": "Date de la commande",
  "orderDelivery": "Commande de livraison",
  "orderDetailsHeading": "Détails de la Commande",
  "orderFailureMessage": "Une erreur s'est produite lors de la création de votre commande. Nous sommes au courant du problème et travaillons à le résoudre. Veuillez réessayer ou contacter {link}",
  "orderFailureMessageForApplePay": "Votre paiement effectué avec Apple Pay a échoué. Votre carte ne sera pas débitée et toute transaction en attente est généralement libérée dans les 24 à 48 heures.",
  "orderFailureMessageForGooglePay": "Votre paiement effectué avec Google Pay a échoué. Votre carte ne sera pas débitée et toute transaction en attente est généralement libérée dans les 24 à 48 heures.",
  "orderHere": "Commandez ici",
  "orderInProgress": "Commande en cours",
  "orderIsBeingMadeYourWay": "{userName}, nous préparons votre commande!",
  "orderName": "Nom de commande",
  "orderNow": "Commandez Maintenant",
  "orderNumber": "Numéro de commande",
  "orderPayment": "Paiement de la commande",
  "orderPickup": "Commande à ramasser",
  "orderPlaced": "Commande effectuée",
  "orderProcessingDisclaimer": "Nous ne commencerons pas à préparer ta commande et ta carte ne sera pas débitée tant que tu n'auras pas appuyé sur «Je suis ici» sur l'écran suivant.",
  "orderProcessingDisclaimerCashPayment": "Nous commencerons seulement à préparer votre commande lorsque vous appuierez sur « Je suis ici » à l’écran suivant.",
  "orderTime": "Heure de la commande",
  "orderingFrom": "Commande de",
  "other": "Autre",
  "otpFormHeadline": "Obtenez des Couronnes à échanger contre des produits au menu",
  "ourMenu": "Notre Menu",
  "outForDelivery": "En cours de livraison",
  "outOfDayparts": "{dayParts} seulement",
  "paymentAddingError": "Les détails de votre carte de crédit sont peut-être erronés ou nous éprouvons des difficultés avec votre carte. Veuillez réessayer ou vérifier auprès de votre banque.",
  "paymentDeclined": "Il nous est impossible de conclure cette transaction. Vérifiez auprès de votre émetteur de carte pour en connaître les raisons.",
  "paymentDeclinedDisclaimer": "Votre commande demeure dans le panier, vous pouvez revenir en arrière pour réessayer",
  "paymentDeclinedHeading": "Oups! Quelque chose n'a pas bien fonctionné et il nous est impossible de compléter cette transaction.",
  "paymentDeletingError": "Une erreur s'est produite lors de la suppression de votre mode de paiement.",
  "paymentDetails": "Détails liés au paiement",
  "paymentDetailsError": "Vérifiez votre carte et essayez à nouveau.",
  "paymentDetailsErrorHeading": "Oups! Les détails de la carte sont incorrects.",
  "paymentLoadingError": "Une erreur s'est produite lors du chargement de vos mode de paiement.",
  "paymentMethod": "Moyen de Paiement",
  "paymentMethodNotAvailable": "Non disponible",
  "paymentMethods": "Modes de paiement",
  "paymentNotSupported": "Veuillez choisir un autre mode de paiement ou un autre restaurant à proximité.",
  "paymentNotSupportedHeading": "Oups! Le restaurant ne supporte pas votre type de carte.",
  "paymentXEndingInY": "Paiement : {cardType} se terminant par {ccLast4}",
  "peanuts": "arachides",
  "perServing": "Par portion",
  "perks": "Couronnes",
  "phoneAppStoresDisclaimers": "Apple et le logo Apple sont des marques de commerce d'Apple Inc., déposées aux États-Unis et dans d'autres pays. L'App Store est une marque de service d’Apple Inc. Google Play est une marque de commerce de Google Inc. Certaines conditions s’appliquent.",
  "phoneNumber": "Numéro de téléphone",
  "phoneNumberDisclaimer": "Le numéro de téléphone enregistré servira aux chauffeurs pour vous rejoindre. En continuant, vous consentez à partager vos coordonnées avec les chauffeurs Door Dash ou Postmates qui livreront vos commandes.",
  "phoneNumberPlaceholder": "+13050000000",
  "phoneNumberRequired": "Numéro de téléphone (requis)",
  "phoneNumberRequiredError": "Le numéro de téléphone est un champ obligatoire.",
  "phoneNumberTooLongError": "Le numéro de téléphone indiqué est trop long.",
  "phoneNumberTooShortError": "Le numéro de téléphone indiqué est trop court.",
  "pickALabel": "Ajouter une étiquette (Obligatoire)",
  "pickUp": "Cueillette",
  "pickUpAt": "Pickup à",
  "pickUpOnly": "Cueillette seulement",
  "pickUpOrder": "Pickup de la commande",
  "pickUpOrderPlaced": "Cueillette de la commande",
  "pickUpOrderSuccessfulAlert": "Votre commande a bien été prise en compte, profitez-en. Le numéro de votre commande est {orderNumber} chez {brand} à {address}.",
  "pickUpTime": "Heure de pickup",
  "pickupNowEta": "Commande prête d’ici 5 à 7 minutes",
  "pickupWindow": "Nous fermons dans {minutes} min. Merci de passer prendre ta commande dès que possible!",
  "placeAnOrderToEarn": "Passez une commande pour gagner",
  "placeOrder": "Passer la commande",
  "placeOrderDescription": "Passer une commande de {serviceMode} de {price}",
  "placeSecureOrder": "{secureOrderIcon} Passer la commande",
  "pleaseHaveYourCashReady": "Veuillez avoir votre argent en main",
  "pleaseReAuthenticateToContinue": "Authentifiez-vous de nouveau pour continuer. Vous serez déconnecté brièvement pour des raisons de sécurité.",
  "pleaseSelect": "Veuillez sélectionner",
  "pleaseTryAgainLater": "Veuillez réessayer plus tard",
  "pleaseTryToRefresh": "Veuillez essayer d’actualiser.",
  "points": "Couronnes",
  "pointsEarned": "{pointsEarned, plural, one {Vous avez obtenu {pointsEarned} Couronne!} other {Vous avez obtenu {pointsEarned} Couronnes!}}",
  "pointsEarnedLabel": "Couronne{points, plural, one {} other {s}} obtenues",
  "pointsExpired": "Couronnes expirées",
  "pointsRedeemed": "Couronne{points, plural, one {} other {s}} réclamées",
  "postalCode": "Code Postal",
  "postalCodeInvalid": "Code Postal Invalide",
  "postalCodeRequiredError": "Le code postal est un champ obligatoire.",
  "preferences": "Préférences",
  "price": "Prix: {price}",
  "pricedAndAvailableError": "Nous avons rencontré un problème technique temporaire lors du traitement de votre commande. Veuillez réessayer.",
  "pricesDiscountsAndAvailabilityAreSbujectToChangeWhenYouReorder": "Les prix, les rabais et la disponibilité des produits peuvent changer lorsque vous commandez à nouveau.",
  "primaryNavLinks": "Navigation Primaire",
  "privacyPolicy": "Politique de Confidentialité",
  "prizes": "Prix",
  "product": "Produit",
  "productDetailCloseContent": "Vous souhaitez quitter sans avoir terminé?",
  "productDetailCloseHeading": "Quitter maintenant",
  "productDetailResetContent": "Le fait de sélectionner une nouvelle option annulera la personnalisation précédemment effectuée.",
  "productDetailResetHeading": "Réinitialiser les modifications",
  "productInformation": "Info sur le produit",
  "profile": "Profil",
  "profileCompletionStarted": "La complétion du profil a commencé !",
  "profileCompletionUpdated": "Complétion du profil mise à jour !",
  "progressbar": "barre de progression",
  "promoCodeCTA": "Vous avez un code promotionnel?",
  "promoCodeLabel": "Entrez le code promotionnel",
  "proteins": "Protéines",
  "province": "Province",
  "pspPaymentDeclinedMessage": "Bonjour {name}, votre transaction a été refusée. Communiquez avec l’émetteur de votre carte pour obtenir de l’aide.",
  "pspPaymentDeclinedTitle": "Carte refusée",
  "pspPaymentDeclinedTransactionForterMessage": "Bonjour {name}, votre transaction a été refusée. Veuillez utiliser un autre mode de paiement.",
  "pspPaymentDeclinedTransactionForterTitle": "Carte refusée",
  "pspPaymentDeclinedTransactionTitle": "Carte refusée",
  "pspPaymentExpiredCardMessage": "Bonjour {name}, la date d’expiration que vous avez introduite est invalide. Veuillez vérifier la date et réessayez.",
  "pspPaymentExpiredCardTitle": "Carte expirée",
  "pspPaymentIncorrectInformationMessage": "Bonjour {name}, les renseignements liés à la carte que vous avez introduits sont inexacts. Vérifiez l’information et réessayez.",
  "pspPaymentIncorrectInformationTitle": "Renseignements de carte inexacts",
  "pspPaymentInvalidCardMessage": "Bonjour {name}, le numéro de carte que vous avez introduit est invalide. Veuillez vérifier les détails de votre carte et réessayez.",
  "pspPaymentInvalidCardTitle": "Carte invalide",
  "pullToRefresh": "Tirez davantage vers le bas pour rafraîchir",
  "purchaseAmount": "Montant",
  "push": "Notifications poussées",
  "pypestreamWelcomeAnon": "Bonjour! Je suis l’assistant numérique {brand} et je suis ici pour vous aider si vous éprouvez des difficultés avec vos commandes et pour répondre à vos questions. Veuillez patienter un petit moment pendant que je consulte votre dossier.",
  "pypestreamWelcomeUser": "Allô {name}! Je suis l’assistant numérique {brand} et je suis ici pour vous aider si vous éprouvez des difficultés avec vos commandes et pour répondre à vos questions. Veuillez patienter un petit moment pendant que je récupère l’historique de vos commandes.",
  "qty": "qté",
  "quantity": "Quantité",
  "questTerms": "{quest} Conditions",
  "question": "Question",
  "receipt": "Reçu",
  "recent": "Récentes",
  "recentItems": "Produits récents",
  "recentItemsFailed": "Oups! Le chargement des articles récents a échoué",
  "recentOrders": "Commandes récentes",
  "recentOrdersDisclaimer": "Les prix, les rabais et la disponibilité des produits peuvent changer lorsque vous commandez à nouveau.",
  "recentOrdersEmptySubHeader": "Allez passer une nouvelle commande dès maintenant!",
  "recents": "Récents",
  "redeem": "Réclamez",
  "redeemApply": "Utilisez {points}",
  "redeemInNext": "À réclamer d’ici",
  "redeemInRestaurant": "Réclamer au Restaurant",
  "redeemNow": "Réclamez maintenant",
  "redeemRemove": "Supprimer {points}",
  "redeemReward": "Réclamez votre récompense",
  "redeemTab": "Réclamez",
  "redeemedRewards": "{redeemedRewards, plural, one {Vous avez réclamé {redeemedRewards} récompense.} other {Vous avez réclamé {redeemedRewards} récompenses.}}",
  "redeeming": "Couronnes réclamées",
  "refresh": "Actualiser",
  "refundEligibilityInfo": "Les commandes sont admissibles à un remboursement partiel ou complet. Sélectionnez parmi vos commandes ci-dessous pour soumettre une demande de remboursement.",
  "regular": "Régulier",
  "reload": "Réapprovisionner",
  "reloadCard": "Réapprovisionner la carte",
  "remove": "Retirer",
  "removeAddressBody": "Êtes-vous sûr de vouloir le supprimer de vos adresses enregistrées ? Cette action ne peut pas être annulée.",
  "removeAddressHeading": "Supprimer cette adresse ?",
  "removeExpiredOfferItem": "Nous avons retiré des produits du panier qui ne sont pas offerts en ce moment.",
  "removeFavorite": "Retirer des favoris?",
  "removeFavoriteConfirm": "Voulez-vous vraiment retirer ce favori?",
  "removeFavoriteOrderSucess": "Commande retirée des favoris.",
  "removeFavoriteSucess": "Votre favori a été retiré.",
  "removeItem": "Retirer un produit",
  "removeItemFromCart": "Êtes-vous sûr de vouloir retirer ce produit, {item}, de votre panier?",
  "removePaymentMethod": "Supprimer le mode de paiement",
  "removeRewardsFromCart": "Retirer récompenses du panier",
  "reorder": "Commander",
  "replace": "Remplacer",
  "requestMyInfo": "Demander mes info",
  "required": "Requis",
  "requiredField": "Il s'agit d'un champ obligatoire",
  "resendCode": "Renvoyer le code",
  "reset": "Réinitialiser",
  "resetCustomizationsDescription": "En sélectionnant cette option, vous supprimerez tout ce que vous avez personnalisé pour votre commande. Voulez-vous continuer?",
  "resetCustomizationsHeader": "Réinitialisez la personnalisation",
  "restartPurchaseProcessButton": "Sélectionnez un nouveau restaurant",
  "restaurantClosed": "Restaurant fermé",
  "restaurantClosedDialogBody": "Pas de souci, tu peux commander d’un autre restaurant à proximité.",
  "restaurantClosedDialogBodyClosestOptionAvailable": "L’option la plus près est :",
  "restaurantClosedDialogBodyDelivery": "Désolés, tous les restaurants qui offrent la livraison sont fermés. Réessaye plus tard ou sélectionne la cueillette.",
  "restaurantClosedDialogButton": "Confirmer nouveau restaurant",
  "restaurantClosedDialogButtonCancel": "Choisir un autre restaurant",
  "restaurantClosedDialogButtonDelivery": "Choisir la cueillette",
  "restaurantClosedDialogHeading": "Restaurant sélectionné fermé",
  "restaurantClosedDialogHeadingDelivery": "Livraison non disponible",
  "restaurantCloses": "Le restaurant ferme dans {minutes} min",
  "restaurantDetails": "Détails du restaurant",
  "restaurantUnavailableErrorMessage": "Le restaurant où vous tentez de commander n'est pas disponible en ce moment.",
  "restaurantUnavailableErrorTitle": "Ce restaurant n’est pas disponible",
  "restaurants": "Restaurants",
  "resultsLeft": "Il reste {count} résultats",
  "retry": "Réesayer",
  "review": "Revoir",
  "reviewYourMeal": "Vérifie ton repas",
  "reviewYourSelection": "Vérifie ta sélection",
  "reward": "Récompense",
  "rewardSavings": "Économies de récompense",
  "rewardUnavailable": "Non valide",
  "rewards": "Récompenses",
  "rewardsMainImage": "L'image principale des récompenses",
  "rewardsPolicy": "Politique de récompenses",
  "royalPerks": "Récompenses King",
  "salt": "Sel",
  "saturatedFat": "Lipides saturés",
  "saturday": "Samedi",
  "save": "Sauvegarder",
  "saveAddressDisclaimer": "Veuillez sauvegarder mon numéro de téléphone et mon adresse de livraison afin de me permettre de régler la facture plus rapidement lors de ma prochaine commande.",
  "saveAddressLabel": "Sauvegarder mes données. {disclaimer}",
  "saveCardDisclaimer": "Enregistrer la carte - En enregistrant votre carte, vous consentez à ce qu'elle soit conservée en dossier et utilisée pour vos achats.",
  "saveCardDisclaimerRedesign": "Enregistrer la carte - En enregistrant votre carte, vous consentez à ce qu'elle soit conservée en dossier et utilisée pour vos achats.",
  "saveChanges": "Enregistrer les modifications",
  "saveFavoriteOrderButton": "Sauvegarder dans les favoris.",
  "saveFavoriteOrderNameError": "Veuillez entrer un nom de commande.",
  "saveFavoriteOrderSucess": "Commande sauvegardée dans les favoris!",
  "saveFavoriteOrderText": "Quel nom voulez-vous donner à cette commande?",
  "saveFavoriteOrderUnsaved": "Vous avez des changements non sauvegardés.",
  "saveFavoriteOrderUnsavedBody": "Voulez-vous continuer sans sauvegarder les modifications apportées dans votre commande favorite?",
  "scan": "Numérisez",
  "searchThisArea": "Rechercher ce secteur",
  "seconds": "secondes",
  "seeDetails": "Détails",
  "select": "Sélectionner",
  "selectACountry": "Sélectionnez un pays",
  "selectAFilter": "Sélectionnez un filtre...",
  "selectLanguage": "Sélectionner une langue",
  "selectLocation": "Sélectionner le restaurant",
  "selectPaymentMethodDrawer": "Sélectionner le mode de paiement",
  "selectRemaining": "Sélectionnes-en {amount} de plus",
  "selectRestaurantToViewOffers": "Sélectionnez un restaurant pour voir les offres locales",
  "selectUpTo": "Sélectionnez jusqu’à {amount} {itemName}",
  "selectionNotAvailable": "Nous sommes désolés, votre choix n’est pas disponible.",
  "sendNewCode": "Envoyer un nouveau code",
  "serviceFee": "Frais de service",
  "serviceFeeDescription": "Les frais de service représentent {percent}% de votre commande avant taxes.",
  "serviceModeDetailsDineInDescription": "Entrez et assoyez-vous. Nous vous appellerons par votre nom lorsque votre commande sera prête.",
  "serviceModeDetailsDineInDescriptionV2": "Au comptoir\n",
  "serviceModeDetailsDineInHeader": "En Restaurant",
  "serviceModeDetailsDriveThruDescription": "Approchez votre voiture et faites-nous savoir que vous avez passé une commande en ligne.",
  "serviceModeDetailsDriveThruDescriptionForMobileOrder": "Rendez-vous en voiture dans la voie réservée aux commandes mobiles et nous sortirons vous porter votre commande.",
  "serviceModeDetailsDriveThruDescriptionV2": "Dans la voie du service au volant\n",
  "serviceModeDetailsDriveThruHeader": "Service Au Volant",
  "serviceModeDetailsDriveThruHeaderForMobileOrder": "Commande mobile au service au volant\n",
  "serviceModeDetailsPickupDescription": "Votre commande sera prête au comptoir à votre arrivée.",
  "serviceModeDetailsPickupDescriptionV2": "Au comptoir\n",
  "serviceModeDetailsPickupHeader": "À Emporter",
  "serviceModeSelectorTitle": "Choisis ton mode de ramassage",
  "serviceVisit": "Couronnes compensatoires",
  "sesame": "sésame",
  "setRestaurantAsFavorite": "Régler ce restaurant en tant que favori",
  "shareMyLocation": "Partager ma position",
  "shellfish": "mollusques et crustacés",
  "showDetails": "Afficher les détails",
  "showLess": "Afficher moins",
  "showMore": "Afficher plus",
  "signIn": "Connexion",
  "signInCodeSentToEmailAgain": "Votre code de connexion a été envoyé à votre adresse courriel! Veuillez vérifier votre dossier de courriels indésirables",
  "signInSuccess": "Vous avez ouvert une session avec succès!",
  "signInToViewOrders": "Connectez-vous pour Voir les commandes.",
  "signInUp": "Inscription/Connexion",
  "signOut": "Déconnexion",
  "signOutConfirmSubheader": "Voulez-vous vraiment vous déconnecter?",
  "signUp": "Inscris-toi",
  "signUpError": "Une erreur s'est produite lors de l'inscription",
  "signUpForPromotionalEmails": "Inscrivez-vous pour recevoir des courriels promotionnels",
  "signUpNow": "Inscrivez-vous maintenant",
  "signUpOrSignIn": "Inscrivez-vous ou connectez-vous",
  "signUpSuccessSignInFail": "Votre compte a été créé. Veuillez ouvrir une session pour continuer.",
  "signUpToContinue": "Inscrivez-vous pour continuer",
  "signUpToContinueDisclaimer": "Les taxes et les frais seront calculés à l’étape finale. Connectez-vous ou inscrivez-vous pour vérifier et passer votre commande.",
  "signupEmailSent": "Nous venons d'envoyer un courriel à {email}. Entrez le code de vérification ci-dessous",
  "sitemap": "Plan du site",
  "skip": "Passer",
  "slowNetworkIssue": "Nous traitons toujours votre demande. Cela peut prendre un peu plus de temps que d'habitude.",
  "smallCartFee": "Frais pour petit panier",
  "smallCartFeeDescription": "Ces frais ne s'appliquent qu'aux commandes de moins de {amount}. Ajoutez des articles pour annuler ces frais.",
  "sodium": "Sodium",
  "someItemsNotAvailable": "Certains produits ne sont pas offerts",
  "somethingWentWrongRemovingAddress": "Une erreur s'est produite lors de la suppression de l'adresse. Veuillez réessayer.",
  "somethingWrong": "Quelque chose n'a pas fonctionné",
  "soy": "soja",
  "startNow": "Commencer maintenant",
  "startOrder": "Débuter une commande",
  "state": "État",
  "stateIsARequiredField": "Vous devez entrer un État",
  "storeAddress": "{name}{conditionalLinebreak}{address1}{linebreak}{city}, {stateProvince} {postalCode}",
  "storeClosed": "LE RESTAURANT QUE VOUS AVEZ SÉLECTIONNÉ N'EST PAS OUVERT EN CE MOMENT.",
  "storeCurrentlyClosed": "Le restaurant est présentement fermé",
  "storeIsClosingError": "Ce restaurant ferme bientôt et n’accepte pas les commandes mobiles.",
  "storeLocator": "Localisateur de restaurant",
  "storeLocatorEmptyStateDefaultBody": "Rechercher un restaurant à proximité.",
  "storeLocatorEmptyStateDefaultTitle": "Trouver un restaurant",
  "storeLocatorEmptyStateFavoritesErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de recharger la page ou recherchez l'adresse dans l'onglet À proximité.",
  "storeLocatorEmptyStateFavoritesErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateFavoritesNoAuthBody": "Pour enregistrer un restaurant dans vos favoris, ouvrez d’abord une session ou créez un compte.",
  "storeLocatorEmptyStateFavoritesNoAuthTitle": "Connectez-vous pour créer des favoris",
  "storeLocatorEmptyStateFavoritesNoStoresBody": "Appuie sur le cœur d'un restaurant pour l'enregistrer en tant que favori.",
  "storeLocatorEmptyStateFavoritesNoStoresTitle": "Nous n’avons pas trouvé de favoris",
  "storeLocatorEmptyStateNearbyErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de saisir l'adresse ou de trouver votre emplacement sur la carte.",
  "storeLocatorEmptyStateNearbyErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateNearbyNoLocationBody": "Partage ta position pour que nous puissions te recommander des restaurants à proximité.",
  "storeLocatorEmptyStateNearbyNoLocationTitle": "Oups!",
  "storeLocatorEmptyStateNearbyNoStoresBody": "Aucun restaurant à proximité n’est disponible pour le moment. Essayez avec une autre adresse ou une autre ville.",
  "storeLocatorEmptyStateNearbyNoStoresTitle": "Nous n’avons pas trouvé de restaurants à proximité",
  "storeLocatorEmptyStateRecentErrorBody": "Il semble qu'il y a eu un problème de notre côté. Essayez de recharger la page ou recherchez l'adresse dans l'onglet À proximité.",
  "storeLocatorEmptyStateRecentErrorTitle": "Oh ! Désolé.",
  "storeLocatorEmptyStateRecentNoAuthBody": "Ouvrez d’abord une session ou créez un compte.",
  "storeLocatorEmptyStateRecentNoAuthTitle": "Ouvrez une session pour voir les restaurants récents",
  "storeLocatorEmptyStateRecentNoStoresBody": "Nous n’avons pas trouvé de restaurants récents. Changeons ça! Essaie d’entrer une adresse et de passer une commande.",
  "storeLocatorEmptyStateRecentNoStoresTitle": "Oh! Un moment",
  "storeUnavailable": "Restaurant non disponible",
  "streetAddress": "Addresse",
  "submit": "Soumettre",
  "submitFeedback": "Soumettre un commentaire",
  "subtotal": "Sous-total",
  "success": "C'est fait!",
  "successfullyCreatedSupportCase": "Votre demande de soutien a bien été soumise!",
  "successfullyUpdatedUserAccountInfo": "Les informations du compte ont été mises à jour.",
  "sugar": "Sucres",
  "sulphurDioxide": "dioxyde de soufre",
  "sunday": "Dimanche",
  "support": "Soutien",
  "supportFormDeliveryActive": "La commande semble ne pas avoir encore été livrée; si vous avez encore besoin d’aide, veuillez nous contacter ci-dessous.",
  "supportFormOrderAlreadyRefunded": "Vous semblez avoir déjà reçu un remboursement pour cette commande; si vous avez encore besoin d’aide, veuillez nous contacter ci-dessous.",
  "supportFormRefundGenericError": "Nous sommes vraiment désolés qu’un problème soit survenu avec votre commande; veuillez décrire le problème ci-dessous.",
  "supportSubcategoryTitle": "Problème : {category}",
  "supportTopics": "Sujets liés au soutien",
  "supportTopicsAll": "Tous les sujets de soutien",
  "takeOut": "À emporter",
  "tapToSeeDetails": "Tapez pour consulter d'autres détails.",
  "tastySwaps": "Échanges savoureux",
  "tax": "Taxes",
  "taxes": "Les taxes",
  "taxesAndFees": "Taxes et Frais",
  "taxesAndFeesButtonAriaLabel": "Afficher les taxes et les frais",
  "taxesAndFeesNextStep": "Calculés à l’étape finale",
  "termsAccessibilityLabel": "Consultez les conditions pour {cardTitle}",
  "termsConditions": "Conditions",
  "termsOfService": "Conditions de Service",
  "theEmailAddressIsInvalid": "L’adresse courriel que vous avez indiquée n’est pas valide ou n’existe pas. Veuillez réessayer avec une adresse courriel valide, ou contactez le service d’assistance.",
  "thereAreErrorsInThisForm": "Il y a {numberOfErrors} erreurs dans ce formulaire",
  "thereIsAnErrorInThisForm": "Il y a une erreur dans ce formulaire",
  "thisMayTakeAFewSeconds": "Cela peut prendre quelques secondes",
  "thursday": "Jeudi",
  "time": "Heure",
  "tip": "Pourboire",
  "tipAmountError": "Veuillez utiliser un caractère numérique.",
  "tipAmountMaxError": "Ne doit pas excéder le sous-total ou 50 $.",
  "tipField": "Entrez un montant pour le pourboire (dollars)",
  "titleAllowLocation": "Votre emplacement n'est pas disponible",
  "to": "à",
  "tooManyAddAccountAttempts": "Vous avez essayé d’ajouter un mode de paiement trop de fois en peu de temps. Veuillez réessayer plus tard.",
  "topLevelUnlocked": "Bravo, {userName} ! Tu as débloqué le niveau supérieur !",
  "total": "Total",
  "trackOrder": "Suivre la commande",
  "trademarkAndCopyright": "MC et © {year} Burger King Company LLC.",
  "transFat": "Lipides trans",
  "transferBalance": "Transférer le solde",
  "treeNuts": "noix",
  "tryAgain": "Essayer à nouveau",
  "tuesday": "Mardi",
  "uhoh": "Oh non...",
  "unableToPlaceOrder": "Impossible de passer la commande",
  "unableToProcessOrder": "Impossible de traiter la commande",
  "unableToReloadCardError": "Nous n’avons pas pu réapprovisionner votre carte.",
  "unauthenticatedFavoritesHeader": "Connectez-vous pour sauvegarder des favoris.",
  "unauthenticatedFavoritesSubtext": "Inscrivez-vous ou connectez-vous pour sauvegarder vos favoris.",
  "unauthenticatedRecentItemsHeader": "Connectez-vous pour voir les articles récents.",
  "unauthenticatedRecentItemsSubtext": "Connectez-vous ou créez un compte pour voir vos articles récents.",
  "unavailable": "Non disponible",
  "unit": "Unité",
  "unitNumber": "Unité {unitNumber}",
  "unitNumberInput": "Unité",
  "unitNumberLabel": "Unité (Optionnel)",
  "unitNumberLabelRequired": "Unité (Requis)",
  "unitedStates": "États Unis",
  "unsavedChangesBody": "Vous avez apporté des modifications à cette adresse. Voulez-vous les enregistrer avant de quitter ?",
  "unsavedChangesHeading": "Modifications non enregistrées",
  "unsavedChangesModalDescription": "Vous avez apporté des changements au produit. Voulez-vous sauvegarder?",
  "unsavedChangesModalHeader": "Changements non sauvegardés",
  "unsupportedCardType": "Désolé, nous n'acceptons pas {cardType} pour le moment.",
  "unverifiedCard": "Carte non vérifiée",
  "upateAddress": "Mettre à jour l'adresse",
  "update": "Mettre à jour",
  "updateBrowserLocationSettings": "Veuillez autoriser la géolocalisation dans les paramètres de votre navigateur et de votre système d’exploitation.",
  "updateCart": "Mettre à jour votre commande",
  "updateCartSuccess": "{itemName} mis à jour dans le panier.",
  "updateDeviceLocationSettings": "Dans les paramètres de votre dispositif veuillez autoriser l'accès de l'appli {brand} à votre localisation.",
  "updateInfoError": "Une erreur s’est produite durant la mise à jour de vos renseignements.",
  "updateItem": "Actualiser le produit",
  "updateNow": "Mettre à jour maintenant",
  "updatePaymentMethod": "Mise à jour du mode de paiement",
  "updateQuantityAndItemWithPrice": "Mettre à jour {quantity} {itemName} pour {price}",
  "uponOrderDelivery": "Lors de la livraison de la commande",
  "uponOrderPickup": "Lors de pickup de la commande",
  "us-calories": "Calories",
  "us-carbohydrates": "Glucides",
  "us-cholesterol": "Cholestérol",
  "us-fat": "Acide gras",
  "us-fiber": "Fibre",
  "us-proteins": "Protéines",
  "us-salt": "Sel",
  "us-saturatedFat": "Acide gras saturé",
  "us-sodium": "Sodium",
  "us-sugar": "Sucre",
  "us-transFat": "Acide gras trans",
  "us-weight": "Poids",
  "useCodeAtCashier": "Utiliser le code à la caisse",
  "useDifferentAddress": "Utiliser une adresse différente",
  "useRewards": "Mon niveau de récompenses",
  "useSavedAddressPhone": "Utiliser l'adresse et le numéro de téléphone sauvegardés",
  "usedAllCoupons": "On dirait que vous avez utilisé tous les coupons actuels.\nNos mises à jour sont récurrentes alors faites attention aux nouveaux.\nMerci pour votre fidélité.",
  "userAwayFromStore": "Vous semblez être bien loin.",
  "userDoesNotExist": "Cet utilisateur n'existe pas",
  "validationCode": "Code de validation",
  "validationError": "Une erreur s'est produite lors de la création de votre commande Veuillez réessayer",
  "validationErrorHeading": "Erreur de commande",
  "verified": "Vérifié",
  "verifyYourEmail": "Confirmer courriel",
  "verifyYourEmailInstructions": "Pour avoir accès à toutes les fonctionnalités de votre compte, veuillez consulter le courriel.",
  "view": "Afficher",
  "viewAll": "Voir tout",
  "viewCart": "Consulter le panier",
  "viewDetails": "Voir les détails",
  "viewDetailsWithOrderNumber": "Voir les détails de la commande numéro {ticketNumber}",
  "viewHistory": "Voir l'historique",
  "viewOrderWithDescription": "Voir la commande {orderDesc}",
  "viewPurchasesAndOffers": "Consultez tous vos achats ici, y compris les Couronnes accumulées et réclamées.",
  "viewRecentOrders": "Voir les commandes récentes",
  "viewTerms": "Conditions",
  "viewYourPurchases": "Consultez ici tous vos achats,\ny compris les Couronnes gagnées et échangées.",
  "visitSupport": "Centre de soutien",
  "visitSupportForHelpWithYourOrder": "Visitez le centre de soutien pour obtenir de l'aide avec votre commande.",
  "visuallyHiddenSignInCodeSentToEmail": "Nous avons envoyé un code de connexion à 6 chiffres à votre adresse courriel. Veuillez saisir le code dans le champ approprié.",
  "visuallyHiddenSignInSuccess": "Vous avez ouvert une session avec succès!",
  "visuallyHiddenVerifyingOTP": "Nous vérifions",
  "waitForReply": "Surveillez votre boîte de réception – nous répondons généralement dans les 24 à 48 heures.",
  "wayToGo": "Bravo ! Il est temps d’échanger",
  "waysToOrder": "Façons de commander",
  "weFoundStoreCloserToYou": "Nous avons trouvé un restaurant plus près de chez vous",
  "weHadToRemoveUnavailableItems": "Nous avons dû retirer certains produits qui ne sont pas offerts dans ce restaurant\n",
  "weHaveSelectedClosestStore": "Nous avons sélectionné le restaurant le plus près d'où vous vous trouvez.",
  "wednesday": "Mercredi",
  "weight": "Poids",
  "welcomeBack": "C’est un plaisir de vous revoir!",
  "whatDoYouNeedHelpWith": "En quoi pouvons-nous vous aider ?",
  "wheat": "blé",
  "whyDoYouNeedMyPhoneNumber": "Pourquoi avez-vous besoin de mon numéro de téléphone ?",
  "work": "Travail",
  "xItems": "{xItems, plural, zero {} one {# produit} two {} few {} many {} other {# produits}}",
  "year": "Année",
  "yearPlaceholder": "AAAA",
  "yes": "Oui",
  "youCompletedYourMonthlyAndProfileChallenges": "Vous avez complété avec succès votre défi du profil\net votre défi mensuel.",
  "youCompletedYourMonthlyChallenge": "Vous avez complété avec succès votre\ndéfi mensuel.",
  "youCompletedYourProfileChallenge": "Vous avez complété avec succès votre\ndéfi du profil.",
  "youHave": "Vous avez",
  "youHaveSuccessfullySubmittedTheForm": "Votre formulaire a bien été envoyé",
  "youQualifyFreeDelivery": "Vous avez droit à la livraison gratuite!",
  "youWillBeCharged": "Vous serez facturé {reloadAmount}",
  "yourAddress": "Ton Adresse",
  "yourCart": "Ton panier",
  "yourCourier": "Ton livreur",
  "yourCrownOrders": "Vos commandes",
  "yourEmail": "Votre courriel",
  "yourNewPaymentMethodHasBeenSuccessfullySaved": "Votre nouvelle méthode de paiement a bien été sauvegardée",
  "yourOrder": "Votre commande",
  "yourPointsWillExpire": "Vos Couronnes expireront le",
  "yourSelectedRestaurantIs": "Vous avez sélectionné le restaurant suivant : {storeAddress}",
  "yourSelectedStore": "Votre restaurant sélectionné",
  "yourWay": "À ton goût : ",
  "yourXPointsAway": "Il vous manque {points} ",
  "youreXAwayFromFreeDelivery": "Il vous manque {amount} pour obtenir la livraison gratuite!",
  "youveGotEnoughCrowns": "Assez de couronnes",
  "zipCode": "Code Postal",
  "zipCodeInvalid": "Code postal non valide",
  "zipCodeRequiredError": "Vous devez entrer un code postal"
}
